<template>
    <b-modal :id="modalName" title="Paste From Excel: " scrollable hide-footer @shown="focusInput">
        <b-form @submit.stop.prevent="processPaste">
            <b-form-group id="textarea-group-paste-text-box">
                <b-form-textarea
                    id="textarea"
                    v-model="inputs.pasteContents"
                    rows="3"
                    max-rows="6"
                    ref="pasteTextBox"
                    placeholder="Paste Excel rows here (SKU header required, or one SKU per line)"
                ></b-form-textarea>
            </b-form-group>
            <b-form-row class="button-row">
                <b-col cols="2">
                    <b-button type="submit" variant="primary" class="btn-sm" :disabled="submitting">
                        <span v-if="submitting">
                            <b-spinner small type="grow"></b-spinner>
                            Pasting...
                        </span>
                        <span v-else>Paste</span>
                    </b-button>
                </b-col>
            </b-form-row>
        </b-form>
    </b-modal>
</template>
<script>
export default {
    props: [],

    data() {
        return {
            modalName: 'modal-inventory-generatepicturefile-excel-paste',
            submitting: false,
            inputs: {
                pasteContents: '',
            }
        }
    },

    methods: {
        processPaste() {
            if (!String(this.inputs.pasteContents || '').trim()) {
                this.showAlertBox('error', 'Empty Paste', 'Please paste content before submitting.')
                return
            }

            this.submitting = true
            this.$emit('pasteContents', this.inputs.pasteContents)
        },

        resetSubmitting() {
            this.submitting = false
        },

        closeAfterSuccess() {
            this.submitting = false
            this.inputs.pasteContents = ''
            this.closeModal(this.modalName)
        },

        focusInput() {
            this.$refs.pasteTextBox.focus()
        }
    },

    mounted() {

    }
}
</script>
<style lang="scss">
.modal-content {
    .modal-footer {
        .footer-block {
            text-align: center;
        }
    }
}
</style>
